import readCookie from "../../utils/readCookie.js";

const KUNDE_COOKIE_NAME = "KUNDE";
const KUNDENNUMMER_SEPARATOR = ":";

/**
 * Liest die Kundennummer aus dem "KUNDE"-Cookie.
 *
 * Cookie-Format: Base64 von `<kundennummer>:<weitere Daten>`
 *
 * @returns {string} Kundennummer oder leerer String, wenn es kein Cookie gibt
 */
export function getKundennummer() {
	const cookieValue = readCookie(KUNDE_COOKIE_NAME);
	if (!cookieValue) {
		return "";
	}

	const decodedValue = atob(cookieValue);
	const separatorIndex = decodedValue.indexOf(KUNDENNUMMER_SEPARATOR);
	if (separatorIndex < 0) {
		return "";
	}

	return decodedValue.substring(0, separatorIndex);
}
